import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'
import { PersonalizationEngineModels } from '@/state/personalization-engine'

import { PersonalizationEngineReportTypeEnum } from '@/enums'
import { usePersonalizationEngineActions } from './use-personalization-engine-actions.hook'

export const usePersonalizationEngine = () => {
  const { t } = useTranslation()

  const { filters } = useSelector(
    ({ personalizationEngine }: ApplicationState) => personalizationEngine,
  )

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const { playerId } = useParams<{ playerId: string }>()

  const {
    getGameCategories,
    getGameProviders,
    getFavoriteGames,
    setPersonalizationEngineFilters,
  } = usePersonalizationEngineActions()

  const [currentTab, setCurrentTab] = useState<string>('casino')

  const buttonsArray = [
    {
      id: 0,
      title: t('personalizationEngine.casino'),
      label: 'casino',
    },
    /* TODO: For the moment we only have info for casino
    {
      id: 1,
      title: t('personalizationEngine.sports'),
      label: 'sports',
    }, */
  ]

  // HERE
  const loadReports = (
    newFilters?: PersonalizationEngineModels.PersonalizationEngineFiltersType,
  ) => {
    setPersonalizationEngineFilters({
      ...filters,
      ...newFilters,
      brandId: brand.siteId.toString(),
    })
    getGameCategories({
      ...filters,
      ...newFilters,
      reportType: PersonalizationEngineReportTypeEnum.CATEGORY,
      brandId: brand.siteId.toString(),
    })
    getGameProviders({
      ...filters,
      ...newFilters,
      reportType: PersonalizationEngineReportTypeEnum.PROVIDER,
      brandId: brand.siteId.toString(),
    })
    getFavoriteGames({
      ...filters,
      ...newFilters,
      reportType: PersonalizationEngineReportTypeEnum.GAME,
      brandId: brand.siteId.toString(),
    })
  }

  useEffect(() => {
    loadReports({ playerId })
  }, [brand, playerId]) // eslint-disable-line

  return {
    filters,
    currentTab,
    setCurrentTab,
    buttonsArray,
  }
}
